import React from 'react';
export function GuideH2({
  id,
  children
}: {
  id: string;
  children: React.ReactNode;
}) {
  return <h2 id={id} className="mt-12 scroll-mt-32 text-2xl font-bold tracking-tight text-zano-charcoal sm:text-3xl" data-id="element-441" data-mp="1r1lout2zcl2u">
      {children}
    </h2>;
}
export function GuideH3({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="mt-8 text-lg font-bold tracking-tight text-zano-charcoal" data-id="element-442" data-mp="20sotu5z15k7e">{children}</h3>;
}
export function GuideP({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mt-4 text-base leading-relaxed text-gray-700" data-id="element-443" data-mp="2apl34dwr6ad0">{children}</p>;
}
export function GuideList({
  items
}: {
  items: string[];
}) {
  return <ul className="mt-4 space-y-2" data-id="element-444" data-mp="2eshdjhc5305v">
      {items.map(item => <li key={item} className="flex items-start gap-2.5 text-base leading-relaxed text-gray-700" data-id="element-445" data-mp="2jpq15xg23wei">
          <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-zano-pink" data-id="element-446" data-mp="keq6mpl72ue4" />
          {item}
        </li>)}
    </ul>;
}
export function GuideCallout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="mt-6 rounded-xl border border-zano-pink/20 bg-zano-blush px-5 py-4 text-base leading-relaxed text-zano-charcoal" data-id="element-447" data-mp="5arsnx9f2ura">
      {children}
    </div>;
}